import { Layout } from 'antd'
import { useState, useMemo, useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { userAtom } from '../recoil/atoms'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import NavDrawer from '../components/drawers/NavDrawer'
import Header from '../components/layout/Header'
import { ErrorBoundary } from 'react-error-boundary'
import FallBackUI from '../components/errors/FallBackUI'
import { capitalizeFirstLetter } from '../utils/Functions'
import { PagesEnum } from '../utils/Enums'

const { Content } = Layout

const HomePage = () => {
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const { tabStatus, orderType } = useParams()
	const usersAtom = useRecoilValue(userAtom)
	const collection = useMemo(
		() => `${pathname.split('/')[1]}${pathname.split('/')[1] === 'biltyManagement' ? capitalizeFirstLetter(pathname.split('/')[2]) : ''}`,
		[pathname]
	)
	const [collapseMenu, setCollapseMenu] = useState(false)

	useEffect(() => {
		if (tabStatus === undefined && PagesEnum[collection]?.tabsEnum !== undefined) {
			navigate(`${pathname}/${Object.values(PagesEnum[collection]?.tabsEnum)?.[0]?.key}`)
		}
	}, [collection, orderType]) // eslint-disable-line

	return (
		<Layout>
			<ErrorBoundary
				fallbackRender={({ error, resetErrorBoundary }) => <FallBackUI component={'Header'} error={error} resetErrorBoundary={resetErrorBoundary} />}
				resetKeys={[tabStatus]}
			>
				<Header props={{ collapseMenu, setCollapseMenu, collection, user: usersAtom }} />
			</ErrorBoundary>
			<NavDrawer collapseMenu={collapseMenu} setCollapseMenu={setCollapseMenu} user={usersAtom} />
			<Content className='!bg-secondaryBackground h-full p-6'>
				<ErrorBoundary
					fallbackRender={({ error, resetErrorBoundary }) => <FallBackUI component={'Header'} error={error} resetErrorBoundary={resetErrorBoundary} />}
					resetKeys={[tabStatus]}
				>
					<Outlet context={{ collection }} />
				</ErrorBoundary>
			</Content>
		</Layout>
	)
}

export default HomePage
